export const translation = {
    error: 'Error',
};
//# sourceMappingURL=en.js.map